import { render } from "./PropertyBenefits.vue?vue&type=template&id=7bc597e5"
import script from "./PropertyBenefits.vue?vue&type=script&lang=js"
export * from "./PropertyBenefits.vue?vue&type=script&lang=js"

import "./PropertyBenefits.vue?vue&type=style&index=0&id=7bc597e5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__